import ProductListQuery from 'Query/ProductList.query';
import { WishlistQuery as SourceWishlistQuery } from 'SourceQuery/Wishlist.query';
import { Field } from 'Util/Query';

/** @namespace Pwa/Query/Wishlist/Query */
export class WishlistQuery extends SourceWishlistQuery {
    _getProductField() {
        return new Field('product').addFieldList(ProductListQuery._getProductInterfaceFields());
    }
}

export default new WishlistQuery();
